import { Search } from "lucide-react";

import { SearchField } from "@/components/ui/search-field";

import { useAbrirPaleta } from "./PaletaProvider";

// TUT-496 — a busca da barra de cima abre a paleta Ctrl+K. Continua sendo o
// campo de busca da casa (`SearchField`, com o mesmo desenho e a mesma altura de
// antes), mas o campo é só a porta: ele não recebe texto, e a paleta é onde se
// digita. É um campo de leitura que abre um diálogo (`aria-haspopup`).
//
// Antes, digitar aqui e dar Enter levava à lista de Processos filtrada. Esse
// caminho ficou DENTRO da paleta ("Ver todos os processos com …"), que acha o
// processo sem sair da tela em que a pessoa está.

/** "⌘K" no Mac e no iPad, "Ctrl K" no resto. */
export function rotuloDoAtalho(): string {
  const plataforma =
    typeof navigator === "undefined" ? "" : navigator.platform || navigator.userAgent;
  return /Mac|iPhone|iPad/u.test(plataforma) ? "⌘K" : "Ctrl K";
}

/**
 * TUT-546 — os textos mudam por casca: o padrão é o do escritório (processo,
 * reclamante, empresa); o portal diz o que a paleta DELE acha.
 */
export function BuscaDoTopo({
  rotulo = "Buscar por processo, reclamante ou empresa",
  placeholder = "Buscar processo, reclamante ou empresa...",
}: {
  rotulo?: string;
  placeholder?: string;
} = {}) {
  const abrir = useAbrirPaleta();
  return (
    <SearchField
      onSubmit={(event) => {
        event.preventDefault();
        abrir();
      }}
    >
      <Search aria-hidden="true" />
      <label className="sr-only" htmlFor="global-search">
        {rotulo}
      </label>
      <input
        id="global-search"
        readOnly
        aria-haspopup="dialog"
        aria-keyshortcuts="Control+K Meta+K"
        value=""
        className="cursor-pointer"
        onClick={() => abrir()}
        // Colar o número do processo na busca do topo (Ctrl+V, ⌘V ou o menu do
        // botão direito) abre a paleta com o texto colado, como antes era
        // colar e dar Enter.
        onPaste={(event) => {
          event.preventDefault();
          abrir(event.clipboardData.getData("text").trim());
        }}
        onKeyDown={(event) => {
          // Quem digita aqui está procurando: a paleta abre já com a tecla.
          if (event.ctrlKey || event.metaKey || event.altKey) return;
          if (event.key === "Enter" || event.key === "ArrowDown" || event.key === " ") {
            event.preventDefault();
            abrir();
          } else if (event.key.length === 1) {
            event.preventDefault();
            abrir(event.key);
          }
        }}
        placeholder={placeholder}
        autoComplete="off"
      />
      <kbd
        aria-hidden="true"
        className="ml-1 shrink-0 rounded border border-border px-1.5 py-0.5 font-mono text-legenda leading-none text-[var(--muted)] max-[720px]:hidden"
      >
        {rotuloDoAtalho()}
      </kbd>
    </SearchField>
  );
}
